import React from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";
import "./SignoutConfirmation.css";

const SignOutConfirmation = ({ onConfirm, onCancel }) => (
  <Modal
    open
    closable={false}
    centered
    footer={null}
    onConfirm={onConfirm}
    onCancel={onCancel}
    width="448px"
    wrapClassName="SignoutConfirmation"
    className="SignoutModalAlert"
  >
    <div className="signoutModal">
      <div className="signoutModalTitle">Log Out</div>
      <div className="signoutModalTitleMessage">Are you sure you want to Log Out?</div>
      <div className="signoutModalBtn">
        <Button
          type="default"
          className="signoutModalCancelBtn"
          onClick={onCancel}
        >
          No
        </Button>
        <Button
          type="primary"
          className="signoutModalConfirmBtn"
          onClick={onConfirm}
        >
          Yes
        </Button>

      </div>
    </div>
  </Modal>
);

export default SignOutConfirmation;
